import React, { createContext } from 'react';
import { useBreakpoint } from './Breakpoint.context';
export var ContainerQueryContext = createContext({
    containerQueryClassName: '',
    styleQueryMode: 'screen'
});
/**
 * A provider that wraps the element to do the container query on
 *
 * This component is NOT meant to be used at the high level (i.e. application or page), but instead wrap individual components/groups of components of interest
 *
 * Per design, when the screen is below 768px the container query system falls back to the "small" breakpoint
 * Therefore we detect the medium breakpoint and return the default values when the screen is below medium
 */
var ContainerQueryProvider = function (_a) {
    var _b = _a.children, children = _b === void 0 ? null : _b, _c = _a.className, className = _c === void 0 ? '' : _c;
    var currentBreakpoints = useBreakpoint();
    return (React.createElement(ContainerQueryContext.Provider, { value: {
            containerQueryClassName: currentBreakpoints.medium ? className : '',
            styleQueryMode: className && currentBreakpoints.medium ? 'container' : 'screen'
        } }, children));
};
export default ContainerQueryProvider;
